module.exports = __webpack_public_path__ + "static/media/michael nguyen.9c5426a2.jpg";